<template>
  <svg
    width="27"
    height="26"
    viewBox="0 0 27 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.5 13C1.5 6.37258 6.87258 1 13.5 1C20.1274 1 25.5 6.37258 25.5 13C25.5 19.6274 20.1274 25 13.5 25C6.87258 25 1.5 19.6274 1.5 13Z"
      fill="#AABED4"
    />
    <path
      d="M1.5 13C1.5 6.37258 6.87258 1 13.5 1C20.1274 1 25.5 6.37258 25.5 13C25.5 19.6274 20.1274 25 13.5 25C6.87258 25 1.5 19.6274 1.5 13Z"
      stroke="white"
      stroke-width="2"
    />
    <g clip-path="url(#clip0_3168_39587)">
      <path
        d="M18 12.5H15.5C14.673 12.5 14 13.173 14 14V17.5C14 18.327 14.673 19 15.5 19H18C18.827 19 19.5 18.327 19.5 17.5V14C19.5 13.173 18.827 12.5 18 12.5ZM17.5 17H16C15.7235 17 15.5 16.776 15.5 16.5C15.5 16.224 15.7235 16 16 16H17.5C17.7765 16 18 16.224 18 16.5C18 16.776 17.7765 17 17.5 17ZM17.5 14.9985H16C15.7235 14.9985 15.5 14.7745 15.5 14.4985C15.5 14.2225 15.7235 13.9985 16 13.9985H17.5C17.7765 13.9985 18 14.2225 18 14.4985C18 14.7745 17.7765 14.9985 17.5 14.9985ZM9 10C9 8.3455 10.3455 7 12 7C13.6545 7 15 8.3455 15 10C15 11.6545 13.6545 13 12 13C10.3455 13 9 11.6545 9 10ZM13.513 19H8C7.7215 19 7.4995 18.77 7.5 18.4915C7.5045 16.014 9.5215 14 12 14C12.344 14 12.678 14.0425 13 14.116V17.5C13 18.065 13.1955 18.581 13.513 19Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_3168_39587">
        <rect
          width="12"
          height="12"
          fill="white"
          transform="translate(7.5 7)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
